import { StyledMainNumbers } from '@/components/styles'
import {NumbersCard} from '@/components'
import { useTranslation } from "react-i18next";

const numbers = [
    {
        ind: 1,
        number: '20+',
        text: <>YEARS OF EACH OF OUR DOCTORS <br/>EXPERTISE</>
    },
    {
        ind: 2,
        number: '8000+',
        text: <>OPERATIONS PERFORMED</>
    },
    {
        ind: 3,
        number: '85+',
        text: <>SERVICES OFFERED</>
    }
]

export default function MainNumbers() {
    const { t } = useTranslation("global");
  return (
    <StyledMainNumbers>
        {/* {t('main.numbers.items', { returnObjects: true }).map(({ number, text}, ind) => <NumbersCard key={ind} number={number} text={text}/>)} */}
        {numbers.map(({ind, number, text}) => <NumbersCard key={ind} number={number} text={text}/>)}
        
    </StyledMainNumbers>
  )
}